import { CalendarCheck, Coffee, Users } from 'lucide-react'
import type { ComponentType } from 'react'
import type { CtaCategory } from '../types/models'

export interface CtaCategoryInfo {
  id: CtaCategory
  name: string
  defaultTitle: string
  defaultSubtitle: string
  placeholder: string
  icon: ComponentType<{ size?: number | string; strokeWidth?: number }>
}

/** Exactly three CTA cards. Newsletter was deliberately dropped. */
export const ctaCategories: CtaCategoryInfo[] = [
  { id: 'book', name: 'Book me', defaultTitle: 'Book me', defaultSubtitle: 'Pick a time that works', placeholder: 'https://calendly.com/…', icon: CalendarCheck },
  { id: 'coffee', name: 'Buy me a coffee', defaultTitle: 'Buy me a coffee', defaultSubtitle: 'Support my work', placeholder: 'https://ko-fi.com/…', icon: Coffee },
  { id: 'community', name: 'Join community', defaultTitle: '', defaultSubtitle: 'Join the community', placeholder: 'https://discord.gg/… or t.me/…', icon: Users },
]

export function ctaById(id: string): CtaCategoryInfo | undefined { return ctaCategories.find((cta) => cta.id === id) }
